var ImageHover = /** @class */ (function () {
    function ImageHover(selector, element) {
        this.isInit = false;
        this.classActive = "-active";
        if (element) {
            this.DOM = {
                $wrapper: $(element),
                $hover: $(element).find(selector + "__hover"),
                $img: $(element).find(selector + "__img")
            };
        }
        else {
            this.DOM = {
                $wrapper: $(selector),
                $hover: $(selector + "__hover"),
                $img: $(selector + "__img")
            };
        }
        if (this.DOM.$wrapper && this.DOM.$hover && this.DOM.$img) {
            this.addEvents();
        }
    }
    ImageHover.prototype.addEvents = function () {
        var _this = this;
        this.DOM.$wrapper.on("mouseenter", function () { return _this.onEnter(); });
        this.DOM.$wrapper.on("mouseleave", function () { return _this.onLeave(); });
    };
    ImageHover.prototype.onEnter = function () {
        if (!this.isInit) {
            this.init();
        }
        else {
            this.DOM.$wrapper.addClass(this.classActive);
        }
        this.DOM.$wrapper.addClass(this.classActive);
    };
    ImageHover.prototype.onLeave = function () {
        this.DOM.$wrapper.removeClass(this.classActive);
    };
    ImageHover.prototype.init = function () {
        var _this = this;
        var src = this.DOM.$img.data("src");
        if (src) {
            this.DOM.$img.attr("src", src);
            this.DOM.$img[0].onload = function () {
                _this.isInit = true;
                _this.DOM.$wrapper.addClass(_this.classActive);
            };
        }
    };
    return ImageHover;
}());

// HACK JS Ancre > BUG dans GridHeader.cshtml ( Impossibilit� de r�aliser une ancre standard )
function jump(h) {
    var top = document.getElementById(h).offsetTop;
    window.scrollTo(0, 200);

    document.getElementById(h).scrollIntoView({
        top: "200px",
        behavior: "smooth"
    });
};